import React, { useContext, useEffect, useState } from 'react';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import endpoints from '../constants/endpoints';
import useFetch from '../hooks/useFetch';
import { Button, CircularProgress, Divider, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip } from '@mui/material';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import useApiRequest from '../services/apiRequest';

type Props = {
    q2: number;
    q3: number;
    threshold: number;
}

function OverpriceResultsTablePrint({ q2, q3, threshold }: Props) {
    const { queryStringConverter} = useApiRequest();
    const { currentPage, setCurrentPage } = useContext(GlobalStateContext);
    const { pageSize, setPageSize } = useContext(GlobalStateContext);
    const { description, filters, searchType: search_type } = useContext(GlobalStateContext);
    const [cFilter, setCFilter] = useState<any>(filters);
    const { overpriceChartFilter } = useContext(GlobalStateContext);
    const {currentUser} = useContext(GlobalStateContext);
    const preco = 'preco'
    const { data, error, loading } = useFetch(`${endpoints.ITEMS + `/${currentUser?.profile.username}`}${queryStringConverter({ page: currentPage, size: pageSize, sort: preco, search_type })}`, JSON.stringify({ description, ...cFilter }), "POST")

    useEffect(() => {
        const price_range = [];
        for (const e of overpriceChartFilter) {
            price_range.push({ begin: e.begin, end: e.end });
        }
        setCFilter({ ...filters, ...{ ["price_range"]: price_range } });
    }, [overpriceChartFilter],);


    const renderPrice = (price: number) => {
        let color;
        if (price <= (q3)) {
            color = "green";
        } else if (price <= (threshold)) {
            color = "yellow";
        } else if (price > (100 * threshold)) {
            color = "gray";
        } else {
            color = "red";
        }

        return <div>
            <span>R$ {price}</span>
            <Divider sx={{ bgcolor: color, height: 3 }} />
        </div>
    }


    return (
        <div>
            {loading || !data
                ? <CircularProgress />
                :
                [
                    <>
                        <Paper>
                            <TableContainer >
                                <Table size="small" aria-label="sticky table">
                                    <TableHead className='bg-gray-100'>
                                        <TableRow>
                                            <TableCell width="10%" key='licitacao' className=''>Licitação</TableCell>
                                            <TableCell width="10%" key='descricao'>Descrição</TableCell>
                                            <TableCell width="10%" key='unidMedida'>Unid.Medida</TableCell>
                                            <TableCell width="10%" key='preco'>Preço unitário (R$)</TableCell>
                                            <TableCell width="10%" key='quantidade'>Quantidade</TableCell>
                                            <TableCell width="10%" key='data'>Período</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {data.data.map((element: any) => (
                                            <TableRow>
                                                <TableCell>{element.id_licitacao}</TableCell>
                                                <TableCell>{element.original_dsc}</TableCell>
                                                <TableCell>{element.dsc_unidade_medida}</TableCell>
                                                <TableCell>{renderPrice(element.preco)}</TableCell>
                                                <TableCell>{element.qtde_item}</TableCell>
                                                <TableCell>{element.perido? element.periodo.slice(0,4) +"/"+ element.periodo.slice(4,6): " " }</TableCell>
                                            </TableRow>
                                        ))}

                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </Paper>
                    </>

                ]
            }

        </div>



    );
}

export default OverpriceResultsTablePrint;
